var _path, _g, _g2, _g3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.04,
    height: 22.61,
    viewBox: "0 0 22.04 22.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "users-qa"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,10.5a.67.67,0,0,1-.4-.7V9.2a2.55,2.55,0,0,1-2.3-2.7V3.7A2.57,2.57,0,0,1,15.5,1h4.7a2.57,2.57,0,0,1,2.7,2.7V6.5a2.57,2.57,0,0,1-2.7,2.7H18.4l-2,1.3A.75.75,0,0,1,15.5,10.5Zm4.7-8.8H15.5a1.89,1.89,0,0,0-2,2V6.5a1.89,1.89,0,0,0,2,2,.43.43,0,0,1,.4.4v1c0,.1,0,.1.1.1h.1l2.1-1.4c.1,0,.1-.1.2-.1h1.9a1.89,1.89,0,0,0,2-2V3.7A2.09,2.09,0,0,0,20.2,1.7Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.22,
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_48",
    "data-name": "Capa 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4,13a.67.67,0,0,1,.4.7v.7a2.49,2.49,0,0,1,2.3,2.7v2.8a2.57,2.57,0,0,1-2.7,2.7H3.8a2.57,2.57,0,0,1-2.7-2.7V17.1a2.57,2.57,0,0,1,2.7-2.7H5.6l2-1.3A.8.8,0,0,1,8.4,13ZM3.8,21.9H8.5a1.89,1.89,0,0,0,2-2V17.1a1.89,1.89,0,0,0-2-2,.43.43,0,0,1-.4-.4v-1c0-.1,0-.1-.1-.1H7.9L5.9,15c-.1,0-.1.1-.2.1H3.8a1.89,1.89,0,0,0-2,2v2.8A1.94,1.94,0,0,0,3.8,21.9Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,18.2a.5.5,0,1,1,0-1h5a.5.5,0,1,1,0,1Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3,20.3a.4.4,0,0,1,0-.8H7.4a.4.4,0,0,1,0,.8Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_49",
    "data-name": "Capa 49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.2,5.8h0A2.58,2.58,0,0,1,3.6,3.2,2.65,2.65,0,0,1,6.2.6,2.65,2.65,0,0,1,8.8,3.2,2.52,2.52,0,0,1,6.2,5.8ZM4.4,3.3A1.79,1.79,0,0,0,6.2,5.1h.2A1.83,1.83,0,0,0,8,3.3,1.79,1.79,0,0,0,6.2,1.5,1.68,1.68,0,0,0,4.4,3.3Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6,10.6A2.24,2.24,0,0,1,2.5,8.8,2.24,2.24,0,0,1,3.6,7,5.24,5.24,0,0,1,9,7a2.24,2.24,0,0,1,1.1,1.8A2.24,2.24,0,0,1,9,10.6a4.73,4.73,0,0,1-2.7.7A4.73,4.73,0,0,1,3.6,10.6ZM3.3,8.8A1.51,1.51,0,0,0,4,9.9a4.71,4.71,0,0,0,4.6,0,1.31,1.31,0,0,0,.7-1.2,1.51,1.51,0,0,0-.7-1.1A4.71,4.71,0,0,0,4,7.6,1.42,1.42,0,0,0,3.3,8.8Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "#292d32",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_50",
    "data-name": "Capa 50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3,17.6h0A2.58,2.58,0,0,1,15.7,15a2.6,2.6,0,1,1,5.2,0,2.58,2.58,0,0,1-2.6,2.6ZM16.4,15a1.79,1.79,0,0,0,1.8,1.8h.2A1.86,1.86,0,0,0,20.2,15a1.79,1.79,0,0,0-1.8-1.8A1.91,1.91,0,0,0,16.4,15Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7,22.3a2.24,2.24,0,0,1-1.1-1.8,2.24,2.24,0,0,1,1.1-1.8,5.23,5.23,0,0,1,5.4,0,2.24,2.24,0,0,1,1.1,1.8,2.24,2.24,0,0,1-1.1,1.8,4.73,4.73,0,0,1-2.7.7A4.07,4.07,0,0,1,15.7,22.3Zm-.4-1.8a1.51,1.51,0,0,0,.7,1.1,4.71,4.71,0,0,0,4.6,0,1.31,1.31,0,0,0,.7-1.2,1.51,1.51,0,0,0-.7-1.1,4.71,4.71,0,0,0-4.6,0A1.91,1.91,0,0,0,15.3,20.5Z",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_51",
    "data-name": "Capa 51"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(15.22 7.4) rotate(-0.27)",
    fontSize: 8,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.97 -0.51)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.97 -0.51)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersQa);
export default __webpack_public_path__ + "static/media/users-qa.e09ad512cdf08c65f8810a5f3b02470b.svg";
export { ForwardRef as ReactComponent };